import React from 'react';
import _ from 'lodash';
import { FormControl, TextField, Typography } from '@mui/material';
import { DebounceInput } from 'react-debounce-input';

import { RequiredField } from '../others/RequiredField';
import { InfoField } from './InfoField';
import { handleShowOn, isInteger } from '../../services/functions';

export const NumberField = props => {
  const { field, formik, getFieldCallback } = props;

  return (
    <FormControl style={{ paddingBottom: 15, display: field.hide ? 'none' : handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }} fullWidth>
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
        <RequiredField required={field.required} isEmpty={!isInteger(formik.values[field.name])} formikError={formik.touched[field.name] && Boolean(formik.errors[field.name])} />
      </Typography>
      <DebounceInput
        debounceTimeout={500}
        element={TextField}
        type="text"
        name={field.name}
        label={field.placeholder}
        value={formik.values[field.name]}
        onChange={formik.handleChange}
        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}
        helperText={formik.touched[field.name] && formik.errors[field.name]}
        variant="standard"
      />
      {
        !_.isEmpty(field.infos)
          ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
          : null
      }
    </FormControl>
  );
};
